import React, { useState, useEffect } from 'react';

interface PopupProps {
  message: string;
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ message, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true); // Start the animation on mount

    const timer = setTimeout(() => {
      handleClose();
    }, 5000); // Automatically close after 2 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false); // Trigger fade-out animation
    setTimeout(onClose, 300); // Remove the popup after the animation ends
  };

  return (
    <div 
      onClick={handleClose}
      className={`popup-container text-container
        ${visible ? 'opacity-100 translate-y-[-2rem]' : 'opacity-0 translate-y-16'}`}
        style={{ bottom: '6rem' }}
      >
      {message}
    </div>
  );
};

export default Popup;